import React, { useState, useEffect } from "react";
import { VALIDATION } from '../commonValidations';
import jwt from 'jwt-decode';
import { getLocalStorageItem } from "../localStorageUtils";
import { Container, Stack, Box, Button, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { useTranslation } from "react-i18next";
import { handleNumberFieldFocus } from "../commonFunction";

export const LocationPointMUI = (props) => {
    const {t} = useTranslation();
    const [details, setDetails] = useState({
        latitude: props.latitude ? props.latitude : '',
        longitude: props.longitude ? props.longitude : '',
    })
    const [errorMessage, setErrorMessage] = useState({
        latitudesError: props.latitudesError,
        longitudesError: props.longitudesError,
    });
    const [urn, setUrn] = useState();

    useEffect(() => {
        if (getLocalStorageItem('id_token')) {
            const decoded = jwt(getLocalStorageItem('id_token'));
            const decoded_urn = decoded.extension_URN
            setUrn(decoded_urn);
        }
    }, [getLocalStorageItem('id_token')]);

    useEffect(() => {
        if (props.latitudesError)
            setErrorMessage({ latitudesError: props.latitudesError })
    }, [props.latitudesError]);

    useEffect(() => {
        if (props.longitudesError)
            setErrorMessage({ longitudesError: props.longitudesError })
    }, [props.longitudesError]);

    const showPosition = (position) => {
        setDetails({
            ...details,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
        })
        props.callBackLocation(position);
    }

    const getLocation = (e) => {
        e.preventDefault();
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(showPosition);
        }
    }

    const handleChange = (e) => {
        e.preventDefault();
        if (e.target.name === props.latitudeName) {
            const limit = 18;
            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
            props.callBackLocation({...details, [e.target.name]: e.target.value.slice(0, limit)});

            if ((e.target.value).length > 0 && VALIDATION.latitudeLongitudeValidation(e.target.value)) {
                setErrorMessage({ ...errorMessage, latitudesError: "" })

                setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })


            } else {
                setErrorMessage({ ...errorMessage, latitudesError: "Please enter valid latitude" })

            }

        }
        if (e.target.name === props.longitudeName) {
            const limit = 18;

            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
            props.callBackLocation({...details,[e.target.name]: e.target.value.slice(0, limit) });

            if ((e.target.value).length > 0 && VALIDATION.latitudeLongitudeValidation(e.target.value)) {
                setErrorMessage({ ...errorMessage, longitudesError: " " })
                setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })

            } else {
                setErrorMessage({ ...errorMessage, longitudesError: "Please enter valid longitude" })

            }

        }
        // if (!props.latitude) {
        //     setErrorMessage({ latitudesError: "Please enter latitude" })
        //     return false;
        // }
        // if (!props.longitude) {
        //     setErrorMessage({ longitudesError: "Please enter longitude" })
        //     return false;
        // }
    };

    return (
        <>
                <Grid container spacing={1}>
                    <Grid item xs={12} lg={6}>
                        <FormControl sx={{ width: '100%'}}>
                            <TextField fullWidth
                            required={props?.notRequired ? false: true}
                                label={props.latitudeName}
                                type="number"
                                onFocus={handleNumberFieldFocus}
                                name={props.latitudeName}
                                value={props.latitude ? props.latitude : details?.latitude}
                                onChange={(e) => handleChange(e)}
                                onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                                disabled={props.isDisabled}
                            ></TextField>
                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.latitudesError}</FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <FormControl sx={{ width: '100%'}}>
                            <TextField fullWidth
                            required={props?.notRequired ? false: true}
                                label={props.longitudeName}
                                name={props.longitudeName}
                                value={props.longitude ? props.longitude : details?.longitude}
                                onChange={(e) => handleChange(e)} 
                                onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                                disabled={props.isDisabled}
                            ></TextField>
                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.longitudesError}</FormHelperText>
                        </FormControl>
                    </Grid>
                </Grid>
            <input className="edittextGetLocation" type="submit" value={t('reg.getLocation')} onClick={(e) => getLocation(e)} disabled={props.isDisabled} />

        </>
    )
}